<template>
    <div class="modal-recharge">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">查询所要扣款的老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                <el-form-item prop="idCard">
                                    <el-input  placeholder="请输入身份证号" v-model="searchForm.idCard" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                            <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                            <el-table-column label="地址" prop="areaName" ></el-table-column>
                            <el-table-column label="详细住址" prop="address" ></el-table-column>
                            <el-table-column prop="checkin" label="入住状态" width="130">
                                <template slot-scope="scope">
                                    <el-tag type="danger" v-show="scope.row.checkinStatus==1">入住中</el-tag>
                                    <el-tag type="danger" v-show="scope.row.checkinStatus==2">已退住</el-tag>
                                </template>
                            </el-table-column>
                             <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                            <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                            <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="small" @click.native.prevent="handleRecharge(scope.row)">扣款</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>

            <el-dialog title='扣费凭证' :visible.sync="voucherDialog" :modal-append-to-body='false' class="dialog" width='400px' center top='15vh' :close-on-click-modal='test'>
                <div id="printTest" >
                    <div class="text">
                        <p>老人姓名：{{result.elderlyName}}</p>
                        <p>扣款金额：{{result.money}}</p>
                        <p v-if="result.startTime!=''">开始日期：{{result.startTime}}</p>
                        <p v-if="result.endTime!=''">结束日期：{{result.endTime}}</p>
                        <p>扣费项目：{{result.deductionItemName}}</p>
                        <p>备注：{{result.remarks}}</p>
                        <p>扣费日期：{{result.createTime}}</p>
                    </div>
                    <div style="margin-top:30px">
                        <p>1、请当面核对票款金额，如有疑问请及时查询</p>
                        <p>2、请妥善保管此收据，查询时需校验此单</p>
                        <p>3、此系临时凭据，不做报销凭证</p>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" >
                    <el-button  type="info" v-print="'#printTest'">打印</el-button>
                </div>
            </el-dialog>

            <Fee ref="myFee" v-show="showModalFee" v-on:closeFee="closeFee" v-on:openVoucher="openVoucher"></Fee>
        </div>
        
        
        
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Fee from "./Fee"


    export default {
        name: 'Add',
        data() {
            return {
                multipleSelection:'',
                showModalFee:false,
                flag:false,
                checked:false,
                loading: false, 
                elderlyInfo:[],
                elderlyRow:'',
                verificationDialog:false,
                statusValue:['全部状态','正常','禁用'],
                totalItems:0,
                voucherDialog:false,
                result:{ //扣费成功返回的数据
                    elderlyName:'',
                    money:'',
                    startTime:'',
                    endTime:'',
                    deductionItemName:'',
                    remarks:'',
                    createTime:''
                },
                searchForm:{
                    name:'',
                    idCard:'',
                    checkinStatus:1,
                    pageSize:20,
                    pageIndex:1,
                },
                rechargeForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    addBalance:'',
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                successInfo:'',
                rules:{
                    addBalance:[
                        { required: true, message: '请输入退款金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },
                verifiyRules:{
                    verifiyBalance:[
                        { required: true, message: '请输入退款金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        components:{
            Fee
        },
        methods: {
            init(){
                this.$refs.searchForm.resetFields()
                this.getElderly()
            },
            formatterTime(cellValue) {
                return timefilters(cellValue)
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            closeFee:function(){
                this.showModalFee = !this.showModalFee;
            },
            handleRecharge(row) {
                this.elderlyRow=row
                this.showModalFee = !this.showModalFee;
                this.$refs.myFee.init(row);
            },
            closeRechargeForm(){
                this.$refs.rechargeForm.resetFields();
            },
            closeVerifiyForm(){
                this.loading=false
                this.$refs.verifiyForm.resetFields();
            },
            openVoucher(data){
                this.result.elderlyName = data.elderlyName;
                this.result.money = data.money;
                this.result.startTime = this.resultTime(data.startTime);
                this.result.endTime = this.resultTime(data.endTime);
                this.result.remarks = data.remarks;
                this.result.createTime = this.resultTime(data.createTime);
                this.result.deductionItemName = data.deductionItemName;
                this.voucherDialog = true;
                this.getList();
            },
            getElderly(){
                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByCheckinStatus",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            resultTime(time) {
                return time?time.replace('T',' ').slice(0,19):""
            },
            
        }
    }


</script>





<style lang="scss" scoped>
    
    .modal-recharge {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;
        .dialog /deep/ .is-disabled .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #000;
            cursor: not-allowed;
        }
        .text{
            font-size: 16px;
            line-height: 25px;
        }
        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
